import { useLocation, useSearchParams } from 'react-router-dom';

export type NavigationState = {
  isOpen: boolean;
  commentId: number | null;
  open: (commentId?: number) => void;
  close: () => void;
};

export function useNavigationState(key: string): NavigationState {
  const [searchParams, setSearchParams] = useSearchParams();
  const streamKey = searchParams.get('comments');
  const rawAnchor = searchParams.get('commentId');
  const anchor = rawAnchor ? parseInt(rawAnchor, 10) : null;

  // The stream is open only if the keys are defined and match
  const isOpen = !!key && streamKey === key;

  const open = (commentId?: number) => {
    // Prevent opening if the key is not yet available
    if (!key) return;

    setSearchParams(
      (prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set('comments', key);

        if (commentId) {
          newParams.set('commentId', commentId.toString());
        } else {
          newParams.delete('commentId');
        }
        return newParams;
      },
      { replace: true },
    );
  };

  const close = () => {
    setSearchParams(
      (prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.delete('comments');
        newParams.delete('commentId');
        return newParams;
      },
      { replace: true },
    );
  };

  return {
    isOpen,
    commentId: isOpen ? anchor : null,
    open,
    close,
  };
}

export function useAnchorUrl(commentId: number): string {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const newParams = new URLSearchParams(searchParams);
  newParams.set('commentId', commentId.toString());
  return `${window.location.origin}${location.pathname}?${newParams.toString()}`;
}
export function useAnchorId(): number | null {
  const [searchParams] = useSearchParams();
  const rawAnchor = searchParams.get('commentId');
  const anchor = rawAnchor ? parseInt(rawAnchor, 10) : null;
  return anchor;
}
